module.exports = function() {
  return new Worker(__webpack_public_path__ + "60f0a91cd8fac8e6809d.worker.js");
};